import * as tools from '../Tools';

export default class Redirect {
    protected firstRun = true;
    // protected url = location.protocol + '//' + location.host + 'Handler/HvD/Redir';
    protected url = '/Handler/HvD/Redir';

    constructor() {
        const _this = this;
        if (document.querySelectorAll('#redir-toggle').length) {
            $('#redir-toggle').bootstrapSwitch({
                onText: 'An',
                offText: 'Aus',
                onInit: () => _this.getState(),
                onSwitchChange: (ev, state) => _this.Change(ev, state)
            });
        }
    }

    Change(event, state) {
        const _this = this;
        if (_this.firstRun) {
            return;
        }
        $("[name='HWP-redir']").val(state ? 'on' : 'off');
        var postData = {
            redir: state
        };
        tools.fetchPOST(_this.url, postData, false).then(() => {
            window.tools.toast('Weiterleitung', 'Daten gespeichert');
        });
    }

    getState() {
        const _this = this;
        var postData = {
            redir: 'state'
        };
        tools.fetchPOST(_this.url, postData, false).then((data) => {
            var btnOn = $(
                '.bootstrap-switch-id-redir-toggle > div:nth-child(1) > span:nth-child(1)'
            )[0];
            if (data === 'on') {
                $("[name='HWP-redir']").bootstrapSwitch('state', true);
                btnOn.style.backgroundColor = '';
                btnOn.title = '';
            }
            if (data === 'auto') {
                $("[name='HWP-redir']").bootstrapSwitch('state', true);
                btnOn.style.backgroundColor = '#c00';
                btnOn.style.color = '#fff';
                btnOn.title =
                    '<i class="icon-alert"></i> Die Weiterleitung wurde automatisch aktiviert!<br />Sie wird wieder deaktiviert sobald die Datenhaltung synchronisiert wurde.';
            }
            _this.firstRun = false;
        });
    }
}
